module.exports = __webpack_public_path__ + "img/1.642d474.png";